import { QuestionRiskOptions } from "../../../../config";

const RiskBadge = ({ value, className = '' }) => {
  const risk = QuestionRiskOptions.find((r) => r.value === String(value));

  if (!risk) return null;

  return (
    <span
      className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-md ${className}`}
      style={{
        backgroundColor: `${risk.color}20`, // light background (opacity)
        color: risk.color,
        border: `1px solid ${risk.color}40`,
        borderRadius: "10px",
        fontSize: "12px"
      }}
    >
      {risk.label}
    </span>
  );
};

export default RiskBadge;